export var ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType["SERVER"] = "server";
  ErrorType["AUTHORIZATION"] = "auth";
  ErrorType["INLINE"] = "inline";
  return ErrorType;
}({});
export var ERRORS = {
  UNKNOWN_COMMAND_FAILURE: {
    code: 'DP-001',
    message: 'Unknown command: ',
    type: ErrorType.SERVER
  },
  MISSING_PRODUCT_TYPE_FAILURE: {
    code: 'DP-101',
    message: 'Items in cart are missing a product type.',
    type: ErrorType.SERVER
  },
  NO_ITEMS_IN_CART_FAILURE: {
    code: 'DP-102',
    message: 'No items in cart.',
    type: ErrorType.SERVER
  },
  GENERIC_FAILURE_ERROR: {
    code: 'DP-103',
    message: 'Sorry, there was a system error. Your account has not been charged. Please try again later.',
    type: ErrorType.SERVER
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/constants/Errors.js
// module id = 668
// module chunks = 11